import React, { useState } from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import styles from './Attachments.module.scss';

interface IAttachmentsProps {
  attachments: {
    hasAttachment: boolean;
    firstCompressedAttachment?: string;
    totalAttachments: number;
  };
  onClickAttachment: () => void;
  fullSize?: boolean;
  fromMessages?: boolean;
  isPdf?: boolean;
  fileName?: string;
  wide?: boolean;
}

const formatFileName = (name: string, maxLength: number): string => {
  const decoded = decodeURIComponent(name);
  return decoded.length > maxLength
    ? `${decoded.slice(0, maxLength)}…`
    : decoded;
};

export const Attachments = ({
  attachments,
  onClickAttachment,
  fullSize = false,
  fromMessages = false,
  isPdf = false,
  fileName,
  wide = false,
}: IAttachmentsProps) => {
  const [hasError, setHasError] = useState<boolean>(false);

  const maxWidth = wide ? '46rem' : undefined;
  const maxFileNameLength = wide ? 48 : 30;

  const renderThumbnail = () => {
    if (isPdf) {
      return <FontAwesomeIcon glyph="file-pdf" size="tiny" weight="regular" />;
    }

    if (attachments.firstCompressedAttachment && !hasError) {
      return (
        <img
          src={attachments.firstCompressedAttachment}
          alt="Attachment Thumbnail"
          onError={() => setHasError(true)}
        />
      );
    }

    return <FontAwesomeIcon glyph="paperclip" size="tiny" weight="regular" />;
  };

  if (!attachments.hasAttachment) {
    return null;
  }

  return (
    <div
      className={`${styles['attachments-container']} ${fullSize ? styles['attachments-container-full-size'] : ''}`}
      style={maxWidth ? { maxWidth } : undefined}
      onClick={() => onClickAttachment()}
    >
      <div
        className={`${styles.thumbnail} ${fullSize ? styles['thumbnail-full-size'] : ''}`}
      >
        {renderThumbnail()}
      </div>
      <div
        className={`${styles['attachment-count']} ${fullSize ? styles['attachment-count-full-size'] : ''} ${fromMessages ? styles['attachment-count-messages'] : ''}`}
      >
        {fullSize ? (
          <FontAwesomeIcon glyph="image" weight="light" />
        ) : fromMessages ? (
          fileName ? (
            formatFileName(fileName, maxFileNameLength)
          ) : (
            'attachment'
          )
        ) : (
          attachments.totalAttachments
        )}
      </div>
    </div>
  );
};
